export default __webpack_public_path__ + "static/Poppins-Medium-2327a1cebab947d9d98bf4949c933de2.woff";